/* eslint-disable no-unused-vars */
import React from 'react';
import type { UseActionDialogReturn } from '../../hooks/useActionDialog';
import { OrganizationDialog } from './OrganizationDialog';
import { ProjectDialog } from './ProjectDialog';
import { EnvironmentDialog } from './EnvironmentDialog';
import { ReleaseAppDialog } from './ReleaseAppDialog';
import { ReleaseAppVersionDialog } from './ReleaseAppVersionDialog';
import { ChannelDialog } from './ChannelDialog';
import { PromotionDialog } from './PromotionDialog';
import { RollbackDialog } from './RollbackDialog';
import { ApiKeyDialog } from './ApiKeyDialog';
import { ApiKeyRevealDialog } from './ApiKeyRevealDialog';
import { InviteDialog } from './InviteDialog';
import { InviteRevealDialog } from './InviteRevealDialog';
import { RuntimeConfigDialog } from './RuntimeConfigDialog';
import { DeleteConfirmDialog } from './DeleteConfirmDialog';
import { IngestionSourceDialog } from './IngestionSourceDialog';
import { IngestionSourceRevealDialog } from './IngestionSourceRevealDialog';
import { OnCallScheduleDialog } from './OnCallScheduleDialog';
import { OnCallShiftDialog } from './OnCallShiftDialog';
import { EscalationPolicyDialog } from './EscalationPolicyDialog';
import { EscalationStepDialog } from './EscalationStepDialog';

type ActionDialogRouterProps = {
  actionDialogReturn: UseActionDialogReturn;
  onNavigate: (path: string, opts?: { replace?: boolean }) => void;
};

function ActionDialogRouter({ actionDialogReturn, onNavigate }: ActionDialogRouterProps) {
  const { actionDialog } = actionDialogReturn;

  if (!actionDialog) return null;

  const props = { actionDialogReturn, onNavigate };

  switch (actionDialog.kind) {
    case 'organization':        return <OrganizationDialog {...props} />;
    case 'project':             return <ProjectDialog {...props} />;
    case 'environment':         return <EnvironmentDialog {...props} />;
    case 'release-app':         return <ReleaseAppDialog {...props} />;
    case 'release-app-version': return <ReleaseAppVersionDialog {...props} />;
    case 'channel':             return <ChannelDialog {...props} />;
    case 'promotion':           return <PromotionDialog {...props} />;
    case 'rollback':            return <RollbackDialog {...props} />;
    case 'api-key':             return <ApiKeyDialog {...props} />;
    case 'api-key-reveal':      return <ApiKeyRevealDialog {...props} />;
    case 'invite':              return <InviteDialog {...props} />;
    case 'invite-reveal':       return <InviteRevealDialog {...props} />;
    case 'runtime-config':      return <RuntimeConfigDialog {...props} />;
    case 'ingestion-source':        return <IngestionSourceDialog {...props} />;
    case 'ingestion-source-reveal': return <IngestionSourceRevealDialog {...props} />;
    case 'oncall-schedule':          return <OnCallScheduleDialog {...props} />;
    case 'oncall-shift':             return <OnCallShiftDialog {...props} />;
    case 'escalation-policy':        return <EscalationPolicyDialog {...props} />;
    case 'escalation-step':          return <EscalationStepDialog {...props} />;
    case 'delete-project':      return <DeleteConfirmDialog {...props} />;
    case 'delete-organization': return <DeleteConfirmDialog {...props} />;
    default:                    return null;
  }
}

export { ActionDialogRouter };
